import { render } from "./MultipleBarcodes.vue?vue&type=template&id=a5d63efa"
import script from "./MultipleBarcodes.vue?vue&type=script&lang=js"
export * from "./MultipleBarcodes.vue?vue&type=script&lang=js"

import "./MultipleBarcodes.vue?vue&type=style&index=0&id=a5d63efa&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/MultipleBarcodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5d63efa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5d63efa', __exports__)) {
    console.log('reload')
    api.reload('a5d63efa', __exports__)
  }
  
  module.hot.accept("./MultipleBarcodes.vue?vue&type=template&id=a5d63efa", () => {
    console.log('re-render')
    api.rerender('a5d63efa', render)
  })

}


export default __exports__